let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("95YXh")).then(() => parcelRequire('gNXvC'));